import {
  useGetDashboardSnapshotQuery,
  useGetNpaDigestQuery,
} from '@shared/api';
import { ActivityWidget } from '../ActivityWidget';
import { TodayWidget } from '../TodayWidget';
import { DashboardError } from './DashboardError';
import { LegalWorkSection } from './LegalWorkSection';
import { ToolsSection } from './ToolsSection';

export function StatutDashboard() {
  const {
    data: snap,
    isLoading: lSnap,
    isError: eSnap,
    refetch: refetchSnap,
  } = useGetDashboardSnapshotQuery();
  const { data: npaDigest } = useGetNpaDigestQuery({ days: 7 });

  if (eSnap && !snap) {
    return (
      <>
        <TodayWidget />
        <ActivityWidget />
        <DashboardError onRetry={refetchSnap} />
      </>
    );
  }

  const contractsTotal = snap?.contracts_total ?? 0;
  const underReview = snap?.contracts_under_review ?? 0;
  const analyzed = snap?.contracts_analyzed ?? 0;

  const precontractsTotal = snap?.precontracts_total ?? 0;

  const templatesTotal = snap?.contract_templates_total ?? 0;
  const templatesActive = snap?.contract_templates_active ?? 0;

  const counterpartiesTotal = snap?.counterparties_total ?? 0;
  const liquidatedCount = snap?.counterparties_liquidated ?? 0;
  const atRiskCount = snap?.counterparties_at_risk ?? 0;

  const claimsTotal = snap?.claims_total ?? 0;
  const activeClaims = snap?.claims_active ?? 0;
  const lawsuits = snap?.claims_lawsuits ?? 0;

  const corrTotal = snap?.correspondence_total ?? 0;
  const unclassified = snap?.correspondence_unclassified ?? 0;
  const returned = snap?.correspondence_returned ?? 0;
  const classified = snap?.correspondence_classified ?? 0;

  const deadlinesTotal = snap?.deadlines_total ?? 0;
  const overdue = snap?.deadlines_overdue ?? 0;
  const within7 = snap?.deadlines_within_7 ?? 0;
  const nextDl = snap?.deadlines_next_due_at
    ? ({ due_at: snap.deadlines_next_due_at } as const)
    : null;

  const checksTotal = snap?.checks_total ?? 0;
  const activeChecks = snap?.checks_active ?? 0;

  const kbCount = snap?.knowledge_total ?? 0;
  const kbTech = snap?.knowledge_tech ?? 0;
  const kbLegal = snap?.knowledge_legal ?? 0;

  const lnaTotal = snap?.lna_total ?? 0;
  const lnaActive = snap?.lna_active ?? 0;
  const lnaExpired = snap?.lna_expired ?? 0;

  const govTotal = snap?.gov_total ?? 0;
  const govInWork = snap?.gov_in_work ?? 0;
  const govOverdue = snap?.gov_overdue ?? 0;

  const chatTotal = snap?.chat_sessions_total ?? 0;
  const lastChat = snap?.chat_last_at
    ? ({ updated_at: snap.chat_last_at } as const)
    : null;

  return (
    <>
      <TodayWidget />
      <ActivityWidget />
      <LegalWorkSection
        isLoading={lSnap}
        precontractsTotal={precontractsTotal}
        contractsTotal={contractsTotal}
        underReview={underReview}
        analyzed={analyzed}
        counterpartiesTotal={counterpartiesTotal}
        atRiskCount={atRiskCount}
        liquidatedCount={liquidatedCount}
        claimsTotal={claimsTotal}
        activeClaims={activeClaims}
        lawsuits={lawsuits}
        corrTotal={corrTotal}
        unclassified={unclassified}
        classified={classified}
        returned={returned}
        deadlinesTotal={deadlinesTotal}
        overdue={overdue}
        within7={within7}
        nextDl={nextDl}
        govTotal={govTotal}
        govOverdue={govOverdue}
        govInWork={govInWork}
        lnaTotal={lnaTotal}
        lnaActive={lnaActive}
        lnaExpired={lnaExpired}
      />
      <ToolsSection
        isLoading={lSnap}
        kbCount={kbCount}
        templatesTotal={templatesTotal}
        kbTech={kbTech}
        kbLegal={kbLegal}
        templatesActive={templatesActive}
        checksTotal={checksTotal}
        activeChecks={activeChecks}
        chatTotal={chatTotal}
        lastChat={lastChat}
        npaDigest={npaDigest}
      />
    </>
  );
}
